import {ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, signal} from '@angular/core';
import {
    AtsScatterChartComponent,
    ChartDataPoint,
    ChartTieringRange
} from '../components/ats-scatter-chart/ats-scatter-chart.component';

const tieringRanges : ChartTieringRange[] = [
    { tierName: 'Tier 0', toValue: 0.3},
    { tierName: 'Tier 1', toValue: 0.8},
    { tierName: 'Tier 2', toValue: 0.9},
    { tierName: 'Tier 3', toValue: 1.1},
    { tierName: 'Tier 4', toValue: 1.2},
];

@Component({
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        AtsScatterChartComponent
    ],
    template: `
        <div class="layout-vbox" style="gap: 10px">
            <div>ATS Scatter Chart</div>
            <app-ats-scatter-chart [data]="accounts()" [ranges]="tieringRanges"></app-ats-scatter-chart>
            <div class="toolbar-horizontal">
                <fluent-button>Add</fluent-button>
                <fluent-button>Dump</fluent-button>
                <fluent-button>Trigger Tooltip</fluent-button>
            </div>
        </div>
    `,
    styles: `
    `
})
export class TestAtsScatterChartComponent implements OnInit{

    protected accounts = signal<ChartDataPoint[]>([]);

    constructor() {
    }

    async ngOnInit(): Promise<void> {
        const tdReq = await fetch('/data/accounts-testdata.json');
        const td = await tdReq.json();
        this.accounts.set(td);
    }

    protected readonly tieringRanges = tieringRanges;
}
